import { useEffect, useRef } from "react";

export const useClickOutside = (onOutsideClick: () => void) => {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOutsideClick();
      }
    };

    document.addEventListener("mousedown", handleClick);

    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [ref, onOutsideClick]);

  return ref;
};

export const useInsideDialogClick = (close: () => void) => {
  const ref = useRef<HTMLElement | null>(null);
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const dialogPaper = document.querySelector(".MuiDialog-paper");
      if (dialogPaper && dialogPaper.contains(e.target as Node)) {
        if (ref.current && !ref.current.contains(e.target as Node)) {
          close();
        }
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [close]);

  return ref;
};
